/**
 * Sends what was dropped on a shapefile tree node to the upload. Every tree drop
 * target shares this, because a dropped folder has to upload the same way wherever
 * the user drops it.
 *
 * A folder is read one level deep, the way the upload modal reads one, so the files
 * inside it go up and the folder itself never does.
 */
import { toast } from "react-toastify";

import {
  DroppedFolder,
  FOLDER_READ_FAILED_MESSAGE,
  flattenDropWithToasts,
  splitDrop
} from "./folderDrop";

export async function uploadDroppedItems({
  transfer,
  shapefileNodeId,
  upload
}: {
  /**
   * What the browser hands the drop handler. It is passed straight through, because
   * the browser empties the item list as soon as the handler returns and
   * splitDrop reads it before its first await.
   */
  transfer: DataTransfer;
  shapefileNodeId: string;
  upload: (args: { files: File[]; shapefileNodeId: string }) => void;
}): Promise<void> {
  // Every tree node hands this to React as an un-awaited async handler, so a folder
  // the browser will not read has to be answered for here
  let dropped: { folders: DroppedFolder[]; files: File[] };
  try {
    dropped = await splitDrop(transfer);
  } catch {
    toast.error(FOLDER_READ_FAILED_MESSAGE);
    return;
  }

  const files = flattenDropWithToasts(dropped.folders, dropped.files);
  if (files.length === 0) return;

  upload({ files, shapefileNodeId });
}
